import { render, staticRenderFns } from "./donation-product-form.vue?vue&type=template&id=5a3424a4&"
import script from "./donation-product-form.vue?vue&type=script&lang=js&"
export * from "./donation-product-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports